
export const vendors = [
    {
        id:'Azure',
        label:'Azure',
        value:'Azure'
    },
    {
        id:'Kyndryl',
        label:'Kyndryl',
        value:'Kyndryl'
    },
    {
        id:'OBS',
        label:'OBS',
        value:'OBS'
    },
    {
        id:'TCS',
        label:'TCS',
        value:'TCS'
    },
    {
        id:'Other',
        label:'Other',
        value:'Other'
    }
    
]